import { GridColDef } from '@mui/x-data-grid-pro';

export const courseColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Holdnavn',
    flex: 1,
  },
  {
    field: 'capacity',
    headerName: 'Kapacitet',
  },
  {
    field: 'enrolledCount',
    headerName: 'Antal deltagere',
  },
  {
    field: 'availableSeats',
    headerName: 'Ledige pladser',
  },
  {
    field: 'lessonCount',
    headerName: 'Antal lektioner',
  },
  {
    field: 'companyName',
    headerName: 'Virksomhed',
    flex: 1,
  },
  {
    field: 'isCompleted',
    headerName: 'Afsluttet',
    valueGetter: ({ value }) => (value ? 'Ja' : 'Nej'),
  },
  {
    field: 'caseworkerName',
    headerName: 'Ansvarlig sagsbehandler',
    flex: 1,
  },
  {
    field: 'teamName',
    headerName: 'Ansvarligt team',
    flex: 1,
  },
  {
    field: 'offerTitle',
    headerName: 'Tilbud',
    flex: 1,
  },
  {
    field: 'educatorNames',
    headerName: 'Undervisere',
    flex: 1,
    valueGetter: ({ value }) => (value as string[]).join(', '),
  },
];
